interface ActionButtonsProps {
  selectedLineIndex: number | null;
  onTender: () => void;
  onReturn: () => void;
  onSupervisorAction: (action: string) => void;
  onPrint: () => void;
  onParkSale: () => void;
  onRecall: () => void;
  onOrderDiscount: () => void;
  onCancelTransaction: () => void;
  onExchange: () => void;
  onAddItemNote: () => void;
}

export default function ActionButtons({ 
  selectedLineIndex, 
  onTender, 
  onReturn, 
  onSupervisorAction, 
  onPrint, 
  onParkSale,
  onRecall,
  onOrderDiscount,
  onCancelTransaction,
  onExchange,
  onAddItemNote
}: ActionButtonsProps) {
  return (
    <div className="flex-1 bg-white border-l border-gray-200 p-4 overflow-y-auto">
      <div>
        <h3 className="text-xs font-bold text-gray-700 mb-2 whitespace-nowrap">Primary Actions</h3>
        <div className="space-y-2">
          <button 
            onClick={onTender}
            className="w-full px-4 py-4 bg-teal-600 hover:bg-teal-700 text-white rounded-lg font-bold text-base whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-money-dollar-circle-line mr-2 text-xl"></i>
            Make Payment
          </button>
        </div>
      </div>

      <div className="mt-4">
        <h3 className="text-xs font-bold text-gray-700 mb-2 whitespace-nowrap">Item Actions</h3>
        <div className="grid grid-cols-2 gap-2">
          <button 
            disabled={selectedLineIndex === null}
            onClick={() => selectedLineIndex !== null && onSupervisorAction('Price Override')}
            className={`px-3 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors col-span-2 ${
              selectedLineIndex === null
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-purple-500 hover:bg-purple-600 text-white cursor-pointer'
            }`}
          >
            <i className="ri-price-tag-3-line mr-1"></i>
            Price Override
          </button>
          
          <button 
            disabled={selectedLineIndex === null}
            onClick={() => selectedLineIndex !== null && onAddItemNote()}
            className={`px-3 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors col-span-2 ${
              selectedLineIndex === null
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-gray-500 hover:bg-gray-600 text-white cursor-pointer'
            }`}
          >
            <i className="ri-sticky-note-line mr-1"></i>
            Add Item Note
          </button>
        </div>
      </div>

      <div className="mt-4">
        <h3 className="text-xs font-bold text-gray-700 mb-2 whitespace-nowrap">Transaction Actions</h3>
        <div className="space-y-2">
          <button 
            onClick={onOrderDiscount}
            className="w-full px-3 py-2.5 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-discount-percent-line mr-1"></i>
            Order Discount
          </button>

          <div className="grid grid-cols-2 gap-2 mb-3">
            <button 
              onClick={onParkSale}
              className="px-3 py-2.5 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-save-line mr-1"></i>
              Park Sale
            </button>
            <button 
              onClick={onRecall}
              className="px-3 py-2.5 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-inbox-unarchive-line mr-1"></i>
              Recall
            </button>
          </div>
          
          <button 
            onClick={onReturn}
            className="w-full px-3 py-2.5 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-arrow-go-back-line mr-1"></i>
            Return
          </button>
          
          <button 
            onClick={onExchange}
            className="w-full px-3 py-2.5 bg-teal-500 hover:bg-teal-600 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-exchange-line mr-1"></i>
            Exchange
          </button>
          
          <button 
            onClick={onCancelTransaction}
            className="w-full px-3 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-close-circle-line mr-1"></i>
            Cancel Transaction
          </button>
        </div>
      </div>
    </div>
  );
}
